import React from 'react';
import { TEXTS } from '../../texts';
import CollapsibleSection from './ExamplePanel';
import { CUT_MUSIC_EXAMPLE_IMAGES, DATA_TEST_IDS } from './consts';
import styles from './index.module.scss';

const HelpModalContent: React.FC = () => (
  <div className={styles.inner}>
    <div
      className={styles.text}
      data-testid={DATA_TEST_IDS.INTRO}>
      {TEXTS.CUT_MUSIC_HELP_MODAL_INTRO}
    </div>

    <ul
      className={styles.list}
      data-testid={DATA_TEST_IDS.LIST}>
      <li className={styles.listItem}>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_0SEC}</li>
      <li className={styles.listItem}>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_30_60SEC}</li>
    </ul>

    <div
      className={styles.sectionTitle}
      data-testid={DATA_TEST_IDS.OVERLAP_TITLE}>
      {TEXTS.CUT_MUSIC_HELP_MODAL_OVERLAP_SECTION}
    </div>

    <div
      className={styles.block}
      data-testid={DATA_TEST_IDS.SHIFT_BLOCK}>
      <div
        className={styles.blockTitle}
        data-testid={DATA_TEST_IDS.SHIFT_TITLE}>
        {TEXTS.CUT_MUSIC_HELP_MODAL_SHIFT_TITLE}
      </div>
      <div
        className={styles.blockDesc}
        data-testid={DATA_TEST_IDS.SHIFT_DESCRIPTION}>
        {TEXTS.CUT_MUSIC_HELP_MODAL_SHIFT_DESC}
      </div>
      <img
        className={styles.image}
        data-testid={DATA_TEST_IDS.SHIFT_IMAGE}
        alt=""
        src={CUT_MUSIC_EXAMPLE_IMAGES.SHIFT}
      />
    </div>

    <div
      className={styles.block}
      data-testid={DATA_TEST_IDS.DROP_BLOCK}>
      <div
        className={styles.blockTitle}
        data-testid={DATA_TEST_IDS.DROP_TITLE}>
        {TEXTS.CUT_MUSIC_HELP_MODAL_DROP_TITLE}
      </div>
      <div
        className={styles.blockDesc}
        data-testid={DATA_TEST_IDS.DROP_DESCRIPTION}>
        {TEXTS.CUT_MUSIC_HELP_MODAL_DROP_DESC}
      </div>
      <img
        className={styles.image}
        data-testid={DATA_TEST_IDS.DROP_IMAGE}
        alt=""
        src={CUT_MUSIC_EXAMPLE_IMAGES.DROP}
      />
    </div>

    <CollapsibleSection title={TEXTS.CUT_MUSIC_HELP_MODAL_EXAMPLE_TITLE}>
      <div
        className={styles.exampleContent}
        data-testid={DATA_TEST_IDS.EXAMPLE_CONTENT}>
        <div
          className={styles.blockDesc}
          data-testid={DATA_TEST_IDS.EXAMPLE_DESCRIPTION}>
          {TEXTS.CUT_MUSIC_HELP_MODAL_EXAMPLE_DESC}
        </div>
        <img
          className={styles.image}
          data-testid={DATA_TEST_IDS.EXAMPLE_0_IMAGE}
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_0SEC}
        />
        <img
          className={styles.image}
          data-testid={DATA_TEST_IDS.EXAMPLE_30_IMAGE}
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_30SEC}
        />
        <img
          className={styles.image}
          data-testid={DATA_TEST_IDS.EXAMPLE_60_IMAGE}
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_60SEC}
        />
      </div>
    </CollapsibleSection>
  </div>
);

export default HelpModalContent;
